import { Component, OnInit, ViewChild } from '@angular/core';
import { Router, NavigationStart ,ActivatedRoute} from "@angular/router";
import {AssessmentService } from "../../services/assessment.service";

@Component({
  selector: 'app-course-assessment-view',
  templateUrl: './course-assessment-view.component.html',
  styleUrls: ['./course-assessment-view.component.scss']
})
export class CourseAssessmentViewComponent implements OnInit {
  assessmentDetails:any='';
  assessment_id:any='';
  course_id:any='';
  capsuleName:any='';
  backLink:any='';
  tab:any;adminData: any;
  constructor(private auth: AssessmentService,private router: Router,private route: ActivatedRoute) { }

  ngOnInit(): void {
    this.adminData = JSON.parse(localStorage.getItem('adminData') || '[]');
    this.capsuleName = localStorage.getItem('capsuleName');
    this.route.queryParams.subscribe(queryParams => {
    this.assessment_id = queryParams['id'];
    this.course_id = queryParams['course_id'];
      this.assessmentDetail(this.assessment_id);
     });
  }
  logout(){
    // localStorage.clear();
     localStorage.removeItem('adminLoginPass');
  localStorage.removeItem('adminData');
     this.router.navigate(['./admin-login']);
    }
   assessmentDetail(id:any) {
     this.auth.assessmentDetail(id).subscribe(
       data=>{
         this.assessmentDetails = data.data;
         //console.log(data.data);
       },error=>{
         alert(error);
       }
     );
   }
}
